import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CursorGlow from '../components/CursorGlow';
import BackgroundEffects from '../components/BackgroundEffects';
import '../styles/Navbar.css';
import '../styles/ContactPage.css';
import '../styles/Buttons.css';
import SEO from '../components/SEO';
import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';
const TOTAL_STEPS = 3;

const budgetOptions = [
  'Menos de $5,000',
  '$5,000 — $15,000',
  '$15,000 — $30,000',
  '$30,000 — $60,000+',
];

const serviceOptions = [
  { value: 'landing', label: 'Landing Page' },
  { value: 'ecommerce', label: 'Tienda en Línea' },
  { value: 'plataforma', label: 'Plataforma Web' },
  { value: 'movil', label: 'App Móvil' },
  { value: 'otro', label: 'Otro / No estoy seguro' },
];

const ContactPage = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    service: '',
    budget: '',
    idea: '',
    timeline: '',
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const updateField = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors((prev) => {
        const next = { ...prev };
        delete next[field];
        return next;
      });
    }
  };

  const validateStep = () => {
    const newErrors = {};
    if (step === 1) {
      if (!formData.name.trim()) newErrors.name = 'Tu nombre es necesario';
      if (!formData.email.trim()) newErrors.email = 'Necesitamos tu email';
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
        newErrors.email = 'Ingresa un email válido';
    }
    if (step === 2) {
      if (!formData.service) newErrors.service = 'Selecciona un servicio';
    }
    if (step === 3) {
      if (!formData.idea.trim()) newErrors.idea = 'Cuéntanos un poco sobre tu idea';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const nextStep = () => {
    if (validateStep()) {
      if (step < TOTAL_STEPS) setStep(step + 1);
      else handleSubmit();
    }
  };

  const prevStep = () => {
    if (step > 1) setStep(step - 1);
  };

  const handleSubmit = () => {
    console.log('Form submitted:', formData.name);
    // e.preventDefault();  // This is important, the email won't send without it

    emailjs
      .send(
        'service_e1svn6s',
        'template_7n1iyc8',
        {
          from_name: formData.name,
          from_email: formData.email,
          phone: formData.phone,
          company: formData.company,
          service: formData.service,
          budget: formData.budget,
          idea: formData.idea,
          timeline: formData.timeline,
          references: formData.references,
        },
        {
          publicKey: '5uhnhP5jIo1TcaTGt',
        }
      )
      .then(
        (result) => {
          // This is if you still want the page to reload (since e.preventDefault() cancelled that behavior)
        },
        (error) => {

        }
      );

    setSubmitted(true);
  };

  const stepTitles = [
    { title: 'Cuéntanos de ti', sub: 'Para poder conocerte mejor' },
    { title: '¿Qué necesitas?', sub: 'Así sabremos cómo ayudarte' },
    { title: 'Platícanos tu idea', sub: 'Nos encanta escuchar ideas nuevas ✨' },
  ];

  return (
    <>
      <SEO 
        title="Contacto" 
        description="¿Tienes una gran idea? Platícanos tu proyecto y recibe una propuesta personalizada en menos de 24 horas. ¡Estamos listos para escucharte!"
        keywords="contacto, cotización, desarrollo de proyectos, agencia digital Guadalajara"
      />
      <CursorGlow />
      <ToastContainer />
      <BackgroundEffects />

      {/* Mini navbar */}
      <nav className="navbar" style={{ background: 'rgba(10,10,10,0.95)' }}>
        <div className="navbar__logo" onClick={() => navigate('/')}>
          <img src="/logo.png" alt="Monologic Solutions" />
          <span className="navbar__logo-text">MONOLOGIC</span>
        </div>
        <button className="navbar__cta" onClick={() => navigate('/')}>
          Volver al Inicio
        </button>
      </nav>

      <div className="contact-page">
        {/* ═══ LEFT PANEL ═══ */}
        <div className="contact-page__left">
          <button className="contact-page__back" onClick={() => navigate('/')}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
            Volver al inicio
          </button>

          <div className="contact-page__greeting">¡Hola! 👋</div>
          <h1 className="contact-page__title">
            PLATÍCANOS<br />
            TU <span className="orange">IDEA</span>
          </h1>
          <p className="contact-page__desc">
            Estamos emocionados de escucharte. Completa el formulario y nuestro equipo
            se pondrá en contacto contigo en menos de 24 horas para comenzar a dar vida
            a tu proyecto.
          </p>

          <div className="contact-page__info">
            <div className="contact-info-item">
              <div className="contact-info-item__icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <path d="M22 6l-10 7L2 6" />
                </svg>
              </div>
              <div>
                <div className="contact-info-item__label">Email</div>
                <div className="contact-info-item__value">contacto@monologicsolutions.com</div>
              </div>
            </div>
            <div className="contact-info-item">
              <div className="contact-info-item__icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
                </svg>
              </div>
              <div>
                <div className="contact-info-item__label">Teléfono</div>
                <div className="contact-info-item__value">+52 33 1848 4205</div>
              </div>
            </div>
            <div className="contact-info-item">
              <div className="contact-info-item__icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
              </div>
              <div>
                <div className="contact-info-item__label">Ubicación</div>
                <div className="contact-info-item__value">Guadalajara, Jalisco, MX</div>
              </div>
            </div>
          </div>
        </div>

        {/* ═══ RIGHT PANEL — FORM ═══ */}
        <div className="contact-page__right">
          {submitted ? (
            <div className="contact-success">
              <div className="contact-success__icon">
                <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#25D366" strokeWidth="2">
                  <path d="M20 6L9 17l-5-5" />
                </svg>
              </div>
              <h2 className="contact-success__title">¡MENSAJE ENVIADO!</h2>
              <p className="contact-success__desc">
                Gracias por contactarnos. Nuestro equipo revisará tu idea y te responderemos en menos de 24 horas.
              </p>
              <button className="btn-primary" onClick={() => navigate('/')}>
                Volver al Inicio
              </button>
            </div>
          ) : (
            <div className="contact-form" key={step}>
              <div className="contact-form__header">
                {/* Step indicator */}
                <div className="contact-form__step-indicator">
                  {[1, 2, 3].map((s) => (
                    <div
                      key={s}
                      className={`step-dot ${s === step ? 'active' : ''} ${s < step ? 'completed' : ''}`}
                    />
                  ))}
                </div>
                <div className="contact-form__step-title">{stepTitles[step - 1].title}</div>
                <div className="contact-form__step-sub">{stepTitles[step - 1].sub}</div>
              </div>

              {/* ═══ STEP 1: Personal Info ═══ */}
              {step === 1 && (
                <>
                  <div className="form-group">
                    <label className="form-label">
                      Tu nombre <span className="required">*</span>
                    </label>
                    <input
                      className={`form-input ${errors.name ? 'error' : ''}`}
                      type="text"
                      placeholder="¿Cómo te llamas?"
                      value={formData.name}
                      onChange={(e) => updateField('name', e.target.value)}
                      autoFocus
                    />
                    {errors.name && <div className="form-error">⚠ {errors.name}</div>}
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      Email <span className="required">*</span>
                    </label>
                    <input
                      className={`form-input ${errors.email ? 'error' : ''}`}
                      type="email"
                      placeholder="tucorreo@ejemplo.com"
                      value={formData.email}
                      onChange={(e) => updateField('email', e.target.value)}
                    />
                    {errors.email && <div className="form-error">⚠ {errors.email}</div>}
                  </div>

                  <div className="form-group">
                    <label className="form-label">Teléfono</label>
                    <input
                      className="form-input"
                      type="tel"
                      placeholder="+52 33 1234 5678 (opcional)"
                      value={formData.phone}
                      onChange={(e) => updateField('phone', e.target.value)}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">Empresa / Marca</label>
                    <input
                      className="form-input"
                      type="text"
                      placeholder="Nombre de tu negocio (opcional)"
                      value={formData.company}
                      onChange={(e) => updateField('company', e.target.value)}
                    />
                  </div>
                </>
              )}

              {/* ═══ STEP 2: Service + Budget ═══ */}
              {step === 2 && (
                <>
                  <div className="form-group">
                    <label className="form-label">
                      ¿Qué servicio te interesa? <span className="required">*</span>
                    </label>
                    <select
                      className={`form-select ${errors.service ? 'error' : ''}`}
                      value={formData.service}
                      onChange={(e) => updateField('service', e.target.value)}
                    >
                      <option value="">Selecciona una opción...</option>
                      {serviceOptions.map((opt) => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </select>
                    {errors.service && <div className="form-error">⚠ {errors.service}</div>}
                  </div>

                  <div className="form-group">
                    <label className="form-label">Presupuesto estimado (MXN)</label>
                    <div className="budget-options">
                      {budgetOptions.map((opt) => (
                        <button
                          key={opt}
                          type="button"
                          className={`budget-pill ${formData.budget === opt ? 'selected' : ''}`}
                          onClick={() => updateField('budget', opt)}
                        >
                          {opt}
                        </button>
                      ))}
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="form-label">¿Cuándo te gustaría comenzar?</label>
                    <select
                      className="form-select"
                      value={formData.timeline}
                      onChange={(e) => updateField('timeline', e.target.value)}
                    >
                      <option value="">Selecciona un plazo...</option>
                      <option value="asap">Lo antes posible</option>
                      <option value="1month">En 1 mes</option>
                      <option value="3months">En 1 a 3 meses</option>
                      <option value="exploring">Solo estoy explorando</option>
                    </select>
                  </div>
                </>
              )}

              {/* ═══ STEP 3: Idea ═══ */}
              {step === 3 && (
                <>
                  <div className="form-group">
                    <label className="form-label">
                      Cuéntanos tu idea <span className="required">*</span>
                    </label>
                    <textarea
                      className={`form-textarea ${errors.idea ? 'error' : ''}`}
                      placeholder="Describe tu proyecto, qué problema resuelve, quién es tu audiencia... ¡no te limites! 🚀"
                      value={formData.idea}
                      onChange={(e) => updateField('idea', e.target.value)}
                      maxLength={2000}
                      autoFocus
                    />
                    <div className="form-char-count">{formData.idea.length} / 2,000</div>
                    {errors.idea && <div className="form-error">⚠ {errors.idea}</div>}
                  </div>

                  <div className="form-group">
                    <label className="form-label">¿Tienes alguna referencia o inspiración?</label>
                    <input
                      className="form-input"
                      type="text"
                      placeholder="URLs de sitios que te inspiren (opcional)"
                      value={formData.references || ''}
                      onChange={(e) => updateField('references', e.target.value)}
                    />
                  </div>
                </>
              )}

              {/* Navigation buttons */}
              <div className="form-buttons">
                {step > 1 && (
                  <button className="form-btn-back" onClick={prevStep} type="button">
                    ← Atrás
                  </button>
                )}
                <button className="form-btn-next" onClick={nextStep} type="button">
                  {step === TOTAL_STEPS ? (
                    <>
                      Enviar Idea
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" />
                      </svg>
                    </>
                  ) : (
                    <>
                      Continuar
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M5 12h14M12 5l7 7-7 7" />
                      </svg>
                    </>
                  )}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ContactPage;
